let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kywQn")).then(() => parcelRequire('9XNrv'));